import Immutable from 'immutable';

import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setVisionOle = (state, { visionOLEData }) => {
  if (!visionOLEData) return state;
  return state.merge({ visionOLEData });
};
const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};
export const callbacks = [
  {
    actionType: ActionTypes.SET_VISION_OLE,
    actionFunction: setVisionOle,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
